import { InsightTable } from './InsightTable';
import { AudienceCount, InsightType } from '../domain';
import { useTranslation } from '../hooks';

type CustomDemographicInsightTableProps = {
  title: string;
  hasChart: boolean;
  isLoading: boolean;
  customInsight?: AudienceCount[];
};

export const CustomDemographicInsightsTable = ({
  title,
  customInsight,
  hasChart,
  isLoading,
}: CustomDemographicInsightTableProps) => {
  const { t } = useTranslation();
  const placeholderMessage = t('insights.placeholder.demographic');

  return (
    <InsightTable
      title={title}
      hasChart={hasChart}
      values={customInsight}
      isLoading={isLoading}
      message={placeholderMessage}
      type={InsightType.demographics}
      showDivider
      isEnabled
    />
  );
};
